import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { appConfigFactory } from '@awp/core/config';
import { ModuleLoaderService, DynamicOutletRegistryService } from '@awp/dynamic-outlet';
import { MY_DATE_FORMATS } from '@awp/core/utils';
import { environment } from '../environments/environment';
import { COMPONENT_REGISTER, MODULE_REGISTER } from './nac-registry';
library.add(fas);
var ɵ0 = appConfigFactory, ɵ1 = { float: 'always' }, ɵ2 = { appearance: 'fill' }, ɵ3 = MY_DATE_FORMATS, ɵ4 = !environment.production;
var AppModule = /** @class */ (function () {
    function AppModule(moduleLoaderService, componentOutletRegistry) {
        moduleLoaderService.register(MODULE_REGISTER);
        componentOutletRegistry.register(AppModule.name, COMPONENT_REGISTER);
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4 };
